import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.style = document.createElement("style")
    this.style.type = "text/css"
    document.head.appendChild(this.style)

    this.style.sheet.insertRule(`#chat-iframe {
      position: unset !important;
      z-index: unset !important;
      width: 100lvw !important;
      height: ${document.documentElement.clientHeight}px !important;
      color-scheme: dark only !important;
    }`, 0)
  }

  disconnect() {
    this.style.remove()
  }
}
